import React, { useState, useEffect } from "react";
import { Grid, Tag, Empty, Divider, Row, Col, message } from "antd";
import axios from "axios";
import Slider from "react-slick";

import FeatureServiceCards from "../../services/FeatureServiceCard";
import NoCapManifest from "../../../nocap.json";
import config from "../../../config";
import Loading from "../../Loading";
import { useLoading } from "../../../hooks";
import { sliderSettings } from "../../../utils/sliderSettings";

const { useBreakpoint } = Grid;

function ServicesPage(props) {
  const [currentServiceCategory, setCurrentServiceCategory] = useState(
    "Service - Associations"
  );
  const [services, setServices] = useState([]);
  const { isLoading, setIsLoading } = useLoading();
  const screens = useBreakpoint();
  const isMobile = screens.xs;

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchServices(props.userLocation.lat, props.userLocation.lng);
    // eslint-disable-next-line
  }, []);

  const fetchServices = async (lat, lng) => {
    try {
      setIsLoading(true);
      const queryParameters = `search-text&lng=${lng}&lat=${lat}&limit=200`;
      const response = await axios.get(
        `${config.SERVICES}/services/search?${queryParameters}`
      );
      const responseServices = response.data;
      setServices(responseServices);
      setIsLoading(false);
    } catch (err) {
      message.error("Something is wrong with your location");
      setIsLoading(false);
    }
  };

  const changeCategory = (e, value) => {
    setCurrentServiceCategory(value);
  };

  const serviceArray = services;
  const filterServices =
    serviceArray.services &&
    serviceArray.services.filter((s) =>
      s.descriptors.categories.includes(currentServiceCategory)
    );

  const bizCards =
    serviceArray.services &&
    filterServices.map((service, index) => {
      return (
        <Col
          key={index}
          xs={24}
          sm={24}
          md={12}
          lg={8}
          xl={6}
          style={{
            marginBottom: 16,
          }}
        >
          <FeatureServiceCards service={service} key={service._id} />
        </Col>
      );
    });

  const settings = {
    ...sliderSettings,
    slidesToShow: 1,
  };

  const servicesCards = isMobile ? (
    <div className="home-services-slider" style={{ width: "100%", padding: "20px 10px" }}>
      <Slider {...settings}>{bizCards}</Slider>
    </div>
  ) : (
    <Row justify="start" gutter={16}>
      {bizCards}
    </Row>
  );

  return (
    <div className="homepage-container">
      <div className="home-tab tab-services">
        {NoCapManifest.services.serviceCategories.map((c, i) => (
          <Tag
            key={c}
            value={c}
            onClick={(e) => changeCategory(e, c)}
            className={
              c === currentServiceCategory
                ? "home-tab-tag-selected"
                : "home-tab-tag"
            }
          >
            {c.substring("Service -".length)}
          </Tag>
        ))}
      </div>
      {isLoading && <Loading />}
      {bizCards && bizCards.length !== 0 ? (
        servicesCards
      ) : (
        <div style={{ padding: "5rem 0" }}>
          <Empty description={<span>Please choose a category from above</span>} />
          <Divider />
        </div>
      )}
    </div>
  );
}

export default ServicesPage;